/**
 * @author vishwadeep.kapoor
 * @extends prod_base_urls
 */
import COMMON_ENDPOINTS from './commons';

const PROXY_BASEURL = 'https://api.zaggle.in/api/v1';
const PROXY_BASEURL_V3 = 'https://api.zaggle.in/api/v3';
const MOBILE_API_BASEURL = 'https://mobile-api.zaggle.in/api';
const MOBILE_IMAGES_BASEURL = 'https://mobile-api.zaggle.in/images'; /** @desc this will be same in all the @environment */
const PAYMENT_URL = {
  WALLET_PAYU: 'https://secure.payu.in/_payment',
  WALLET_MOBIWIK: 'https://walletapi.mobikwik.com/wallet',
};

const CLIENT_SERIES = {
  MANIPAL_SERIES: '2597',
  PROPEL_CORPORATE_GIFTING: '5066',
};

const CAPTCHA_KEY = '';

const PROD_ENDPOINTS = {
  ...COMMON_ENDPOINTS({ PROXY_BASEURL, PROXY_BASEURL_V3, MOBILE_API_BASEURL, MOBILE_IMAGES_BASEURL, PAYMENT_URL, CLIENT_SERIES, CAPTCHA_KEY }),
};

export default PROD_ENDPOINTS;



// WEBPACK FOOTER //
// client/config/endPoints/prod.js